"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _enum = require("../../shared/enum");

var _utils = require("../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * init track
 *
 * @param {*} scout
 */
function init(scout) {
  var did = getDid();
  var device_id = _jsCookie["default"].get(scout.options.deviceIdKey || _enum.cookieNameEnum.deviceId) || '';
  var bi_device_id = _jsCookie["default"].get(scout.options.biDeviceIdKey || _enum.cookieNameEnum.biDeviceId) || '';
  var client_type = _jsCookie["default"].get(_enum.cookieNameEnum.deviceId) ? 'app' : 'h5';
  var app_version = _jsCookie["default"].get(_enum.cookieNameEnum.version) || '';
  var fe_ua = window.navigator.userAgent || '';
  var os_type = getOSType();
  var spr_c = getSprC();
  return function (ctx) {
    var app_key = scout.options.appKey;
    var userid_key = scout.options.useridKey;
    var useridnum_key = scout.options.useridnumKey;
    var userid = _jsCookie["default"].get(userid_key || _enum.cookieNameEnum.userid) || '';
    var userid_num = _jsCookie["default"].get(useridnum_key || _enum.cookieNameEnum.useridNum) || '';
    var referer_url = document.referrer || '';
    var page_url = window.location.href || '';
    var page_pathname = window.location.pathname || '';
    var time_stamp = Date.now();
    var $timezone_offset = scout.options.$timezone_offset || new Date().getTimezoneOffset();
    var cookie_length = document.cookie.length;
    var channel = getChannelFrom();
    var page = getPageName(scout); // 蓝兔 App RN 版本号

    var version = _jsCookie["default"].get('app-version') || ''; // 蓝兔 App 原生版本号

    var native_version = _jsCookie["default"].get('native-version') || '';
    /**
     * App 类型
     *   - lantu: 蓝兔 App
     *   - others: 其他（不重要）
     */

    var app = navigator.userAgent.includes('LanTu') ? 'lantu' : 'others';
    /**
     * 蓝兔 web tag
     */

    var bundle_tag = _jsCookie["default"].get('bundle_tag') || '';
    ctx.baseData = {
      app: app,
      app_key: app_key,
      app_version: app_version,
      bi_device_id: bi_device_id,
      channel: channel,
      client_type: client_type,
      cookie_length: cookie_length,
      device_id: device_id,
      did: did,
      fe_ua: fe_ua,
      os_type: os_type,
      page_url: page_url,
      page_pathname: page_pathname,
      page: page,
      referer_url: referer_url,
      spr_c: spr_c,
      time_stamp: time_stamp,
      $timezone_offset: $timezone_offset,
      userid: userid,
      userid_num: userid_num,
      version: version,
      native_version: native_version,
      bundle_tag: bundle_tag
    };
  };
}
/**
 * 获取渠道来源
 *
 * @returns {string} 渠道来源
 */


function getChannelFrom() {
  // 如果 cookie 中存在的话，则优先取 cookie 中的值
  var channelFrom = _jsCookie["default"].get(_enum.cookieNameEnum.channelFrom) || '';
  if (channelFrom) return channelFrom; // 获取 URL 中的渠道来源

  var channelSearch = window.location.search.match(/channelFrom=([\w\_]+)/); // 如果 cookie 中不存在，则看 URL 中是否携带渠道来源

  if (!channelFrom && channelSearch && channelSearch[1]) return channelSearch[1];
  return 'otherBrowser';
}
/**
 * 获取did
 *
 * @returns {string} did
 */


function getDid() {
  var did = _jsCookie["default"].get(_enum.cookieNameEnum.did) || '';
  if (did) return did;
  did = generateDid();

  _jsCookie["default"].set(_enum.cookieNameEnum.did, did, {
    expires: 365,
    domain: window.location.host.split('.').slice(-2).join('.').split(':')[0]
  });

  return did;
}
/**
 * 生成did
 *
 * @returns {string} did
 */


function generateDid() {
  var hexDigits = '0123456789abcdef';
  var ary = Array.from({
    length: 36
  }).map(function (i) {
    return hexDigits.substr(Math.floor(Math.random() * 0x10), 1) || '';
  });
  ary[14] = '4';
  ary[19] = hexDigits.substr(ary[19] & 0x3 | 0x8, 1);
  ary[8] = ary[13] = ary[18] = ary[23] = '-';
  return ary.join('');
}
/**
 * 获取os_type
 *
 * @returns {string} os_type
 */


function getOSType() {
  var osType = '';
  var ua = window.navigator.userAgent.toLocaleLowerCase(); // 判断是否在趣店内 APP 里

  var cookieDevice = _jsCookie["default"].get('device') || '';
  cookieDevice = cookieDevice.toLowerCase();
  var matches = [function () {
    return /alipayclient/i.test(ua) ? 'alipay' : '';
  }, function () {
    return cookieDevice && ~['ios', 'android'].indexOf(cookieDevice) ? "".concat(cookieDevice, "InApp") : '';
  }, function () {
    return /iphone|ipad|ipod|mac os/.test(ua) ? 'ios' : '';
  }, function () {
    return /android/.test(ua) ? 'android' : '';
  }, function () {
    return 'other';
  }];
  return matches.reduce(function (acc, cur) {
    if (acc) return acc;
    return cur();
  }, '');
}
/**
 * 获取用户广告推广来源
 *
 * @returns {string} 用户广告推广来源
 */


function getSprC() {
  var newSprC = 'other';
  var ref = document.referrer || ''; // 第一次进入来分期才记录

  if (ref.indexOf('lfq') > -1) return;
  newSprC = _jsCookie["default"].get('fromApp') === 'LFQ' ? handleFromApp() : handleFromWeb(); // 更新 cookie

  _jsCookie["default"].set(_enum.cookieNameEnum.sprc, newSprC, {
    expires: 365,
    domain: window.location.host.split('.').slice(-2).join('.')
  });

  return newSprC;
}

function handleFromWeb() {
  var sprCFromSearch = (0, _utils.parseQuery)().spr_c || '0';
  var sprC = _jsCookie["default"].get(_enum.cookieNameEnum.sprc) || '';
  var sprCArr = sprC === '' ? [] : sprC.split('.');

  if (sprCFromSearch === '0' || !sprCArr.includes(sprCFromSearch)) {
    if (sprCArr.length <= 2) {
      sprCArr.push(sprCFromSearch);
    } else {
      sprCArr.splice(1, sprCArr.length - 2);
      sprCArr.push(sprCFromSearch);
    }

    return sprCArr.join('.');
  }

  return sprC;
}

function handleFromApp() {
  // 限制的最低版本号 4.0.2
  var limitVersion = '4.0.2'; // 获取版本号

  var version = _jsCookie["default"].get(_enum.cookieNameEnum.version); // 获取 sprc


  var sprC = version >= limitVersion ? _jsCookie["default"].get('channel') : 'null';
  return sprC;
}

function getPageName(scout) {
  var curPath = window.location.pathname;
  var pageName = scout.options.pageNames[curPath] || ''; // 如果没有pageName且路径是'/a/b/c'形式，转为'a_b_c'

  if (!pageName) {
    pageName = curPath.replace(/\//g, '_').substring(1);
  }

  return pageName;
}

var _default = {
  init: init,
  name: 'baseData'
};
exports["default"] = _default;